import { UsuarioService } from '../../services/usuario.service';
import { ClienteService } from '../../services/cliente.service';
import { NuevoUsuarioViewModel } from '../../models/viewmodels/UsuarioViewmodel';
import { Router } from '@angular/router';
var NuevoUsuarioComponent = /** @class */ (function () {
    function NuevoUsuarioComponent(usuarioService, clienteService, router) {
        this.usuarioService = usuarioService;
        this.clienteService = clienteService;
        this.router = router;
        this.tags = [];
        this.clientes = [];
        this.autocompleteItems = [];
        this.usuario = new NuevoUsuarioViewModel();
        this.checkRol = [];
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.errores = new Array();
    }
    NuevoUsuarioComponent.prototype.ngOnInit = function () {
        this.spinner.isRunning = false;
        this.roles = this.usuarioService.obtenerRoles();
    };
    NuevoUsuarioComponent.prototype.filtrar = function (event) {
        var _this = this;
        if (event.query.length > 3) {
            return this.clienteService.listado(0, 10, event.query).subscribe(function (response) {
                _this.clientes = response.clientes;
            });
        }
    };
    NuevoUsuarioComponent.prototype.customTrackBy = function (index, rol) {
        return rol.id;
    };
    NuevoUsuarioComponent.prototype.rolSeleccionado = function (event, rol) {
        if (event.target.checked) {
            this.usuario.roles.push(rol);
        }
        else {
            this.usuario.roles = this.usuario.roles.filter(function (r) { return r.id != rol.id; });
        }
    };
    NuevoUsuarioComponent.prototype.onSubmit = function () {
        var _this = this;
        this.spinner.isRunning = true;
        this.alert.visible = false;
        this.usuario.clientes = this.tags;
        this.usuarioService.guardar(this.usuario)
            .map(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Nuevo usuario";
            if (result.status == 201) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "El usuario se ha creado correctamente";
                _this.usuario = new NuevoUsuarioViewModel();
                _this.tags = [];
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "El usuario no se ha podido crear. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
            for (var i = 0; i < _this.checkRol.length; i++) {
                _this.checkRol[i] = false;
            }
        })
            .subscribe(function (data) {
        }, function (error) {
            var json = error.json();
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Nuevo usuario";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "El usuario no se ha podido crear. Por favor vuelva a intentarlo.";
            if (json.modelState) {
                for (var key in json.modelState) {
                    if (json.modelState[key].length == 1) {
                        _this.errores.push(json.modelState[key]);
                    }
                    else {
                        for (var i = 0; i < json.modelState[key].length; i++) {
                            _this.errores.push(json.modelState[key][i]);
                        }
                    }
                }
            }
        });
    };
    NuevoUsuarioComponent.prototype.volver = function () {
        this.router.navigate(['dashboard/clientes']);
    };
    NuevoUsuarioComponent.ctorParameters = function () { return [{ type: UsuarioService }, { type: ClienteService }, { type: Router }]; };
    return NuevoUsuarioComponent;
}());
export { NuevoUsuarioComponent };
//# sourceMappingURL=nuevo-usuario.component.js.map


// WEBPACK FOOTER //
// nuevo-usuario.component.js